import Vue from 'vue';
import VueI18n from 'vue-i18n';
import zhCnLocale from 'view-design/dist/locale/zh-CN';

import { localRead } from '@/libs/util';
import Axios from 'axios';
import { clientTool, isClient } from '@/libs/client';

Vue.use(VueI18n);

const el_zh: any = {
    pagination: {
        total: '总数',
        pagesize: '/页',
    },
    select: {
        noData: '暂无数据',
    },
};
const el_en: any = {
    pagination: {
        total: 'total',
        pagesize: '/page',
    },
    select: {
        noData: 'No Data',
    },
};

const systemConfigLanguages = [
    'zh-CN',
    'en-US',
    'vi-VN',
    'th-TH',
    'zh-TW',
    'id-ID',
    'ms-MY',
    'ko-KR',
    'pt-BR',
    'km-KH',
    'fil-PH',
    'fr-FR',
    'es-ES',
    'ru-RU',
    'hi-IN',
    'tr-TR',
    'bn-BD',
    'my-MM',
];

// 自动根据浏览器系统语言设置语言
export function getLang() {
    let navLang = navigator.language;
    if (navLang.indexOf('zh') > -1) {
        if (['zh-HK', 'zh-TW', 'zh-hk', 'zh-tw'].includes(navLang)) {
            navLang = 'zh-TW';
        } else {
            navLang = 'zh-CN';
        }
    } else if (navLang.indexOf('en') > -1) {
        navLang = 'en-US';
    } else if (navLang.indexOf('vi') > -1) {
        navLang = 'vi-VN';
    } else if (navLang.indexOf('th') > -1) {
        navLang = 'th-TH';
    } else if (navLang.indexOf('id') > -1) {
        navLang = 'id-ID';
    } else if (navLang.indexOf('ms') > -1) {
        navLang = 'ms-MY';
    } else if (navLang.indexOf('ko') > -1) {
        navLang = 'ko-KR';
    } else if (navLang.indexOf('pt') > -1) {
        navLang = 'pt-BR';
    } else if (navLang.indexOf('km') > -1) {
        navLang = 'km-KH';
    } else if (navLang.indexOf('fil') > -1) {
        navLang = 'fil-PH';
    } else if (navLang.indexOf('fr') > -1) {
        navLang = 'fr-FR';
    } else if (navLang.indexOf('es') > -1) {
        navLang = 'es-ES';
    } else if (navLang.indexOf('ru') > -1) {
        navLang = 'ru-RU';
    } else if (navLang.indexOf('hi') > -1) {
        navLang = 'hi-IN';
    } else if (navLang.indexOf('tr') > -1) {
        navLang = 'tr-TR';
    } else if (navLang.indexOf('bn') > -1) {
        navLang = 'bn-BD';
    } else if (navLang.indexOf('my') > -1) {
        navLang = 'my-MM';
    }
    const localLang = systemConfigLanguages.includes(navLang) ? navLang : false;
    return localRead('local') || localLang || 'en-US';
}

export function initLanguage(lang: string) {
    if (systemConfigLanguages.includes(lang)) {
        return lang;
    }
    return getLang();
}

Vue.config.lang = getLang();

// vue-i18n 6.x+写法
// tslint:disable-next-line: no-empty
Vue.locale = () => {};
// const messages = {
//     // @ts-ignore
//     'zh-CN': Object.assign(zhCnLocale, customZhCn, ...{ el: el_zh }),
//     // 'en-US': Object.assign(enUsLocale, customEnUs),
//     // 'vi-VN': Object.assign(viVNLocale, customViVN),
// };
const i18n = new VueI18n({
    locale: getLang(),
    messages: {},
    fallbackLocale: 'zh-CN',
    silentTranslationWarn: true,
});

const loadedLanguages = ['zh-CN']; // 我们的预装默认语言

function setI18nLanguage(language: string) {
    i18n.locale = language;
    Axios.defaults.headers.common['Accept-Language'] = language;
    (document as any).querySelector('html').setAttribute('lang', language);
    if (isClient() && clientTool && clientTool.i18n) {
        // 桌面端不支持时，重置为英文
        if (['tr-TR', 'bn-BD', 'my-MM'].includes(language)) {
            clientTool.i18n.changeLanguage('en-US');
        } else {
            clientTool.i18n.changeLanguage(language);
        }
    }
    return language;
}

export function loadLanguageAsync(language: string) {
    // 如果语言已经加载
    // if (loadedLanguages.includes(language)) {
    //     return Promise.resolve(setI18nLanguage(language));
    // }
    console.log('language', language);
    // 开发环境下, 中文直接用 index.ts
    if (process.env.NODE_ENV === 'development' && language === 'zh-CN') {
        return import('./lang/zh-CN/index').then((zh) => {
            const el: any = ['zh-CN', 'zh-TW'].includes(language) ? el_zh : el_en;
            i18n.setLocaleMessage(language, { ...zhCnLocale, ...zh.default, ...el });
            loadedLanguages.push(language);
            return setI18nLanguage(language);
        });
    }

    // 如果尚未加载语言
    // @ts-ignore
    return Promise.all([
        import(/* webpackChunkName: "lang-[request]" */ `./lang/${language}/all.json`),
        ['km-KH', 'ms-MY', 'fil-PH', 'bn-BD', 'my-MM'].includes(language) ? import(/* webpackChunkName: "lang-iview-[request]" */ `./lang/${language}/iview.json`) : import(/* webpackChunkName: "lang-iview-[request]" */ `view-design/dist/locale/${language}.js`),
    ]).then(
        ([json, json2]) => {
            const el: any = ['zh-CN', 'zh-TW'].includes(language) ? el_zh : el_en;
            i18n.setLocaleMessage(language, Object.assign(json2.default, json.default, el));
            loadedLanguages.push(language);
            return setI18nLanguage(language);
        },
    );
}

export default i18n;
